import * as React from "react";
import { List, Datagrid, TextField, ReferenceField, SelectInput, TextInput, required, SimpleForm, Filter, Create, ReferenceInput, NumberInput, NumberField, FunctionField, Show, SimpleShowLayout, ShowButton } from 'react-admin';
import { AutocompleteInput, usePermissions } from 'react-admin';
import DateBetweenInput from "../dateFilter/DateBetweenInput"
import BalanceButton from "../buttons/balanceButton";
import { useLocation } from "react-router-dom";
import { cloneElement } from 'react';
import {
    useListContext,
    TopToolbar,
    CreateButton,
    ExportButton,
    sanitizeListRestProps,
    Button,
    BooleanField
} from 'react-admin';
import { FilterList } from "@material-ui/icons";
import { Redirect } from "react-router-dom";

const ListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        setFilters,
        maxResults,
        ...rest
    } = props;
    const {
        currentSort,
        resource,
        displayedFilters,
        filterValues,
        basePath,
        showFilter,
        total,
    } = useListContext();
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            <Button onClick={() => setFilters({})} label="Limpiar">
                <FilterList />
            </Button>

            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            {permissions.includes("transactions.create") &&
                <CreateButton basePath={basePath} label="Crear" />
            }
            {permissions.includes("transactions.export") &&
                <ExportButton
                    label="Exportar csv"
                    disabled={total === 0}
                    resource={resource}
                    sort={currentSort}
                    filterValues={filterValues}
                    maxResults={maxResults}
                />
            }
            <BalanceButton />
        </TopToolbar>
    );
};

export const TransactionList = props => {
    const search = useLocation().search;
    const balanceShow = new URLSearchParams(search).get("balanceShow");
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    return (
        <List filters={<TransactionFilter />}{...props} sort={{ field: 'id', order: 'DESC' }} actions={<ListActions />} title="Transacciones">
            <Datagrid>
                <ShowButton label="Ver" />
                <TextField source="id" label="N°" />
                <TextField source="transactionId" label="Id" sortable={false} />
                {(permissions.includes("users.list")) ?
                    <ReferenceField source="userId" label='Usuario' reference="users" link="show">
                        <FunctionField label="Nombre completo" render={record => `${record.firstname} ${record.lastname}`} link="show" />
                    </ReferenceField>
                    : null}
                <FunctionField render={record => {
                    if (record.machine_type === 'secadora') {
                        return 'S';
                    } else if (record.machine_type === 'lavadora') {
                        return 'L';
                    }
                    return '';
                }} label="Tipo máquina" />
                <TextField source="machineId" label="Máquina" sortable={false} />
                {(permissions.includes("buildings.list")) ?
                    <ReferenceField source="buildingId" label='Edificio' reference="buildings">
                        <FunctionField label="Edificio" render={record => `${record.address}`} link="show" />
                    </ReferenceField>
                    : null}
                <FunctionField render={record => {
                    if (record.role === 'USER' || record.role === 'postgres') {
                        return `${record.transactionType.toUpperCase()}`;
                    } else {
                        if (record.transactionType === 'pago') {
                            return 'USO PERSONAL';
                        }
                        return `${record.transactionType.toUpperCase()}`;
                    }
                }} label="Tipo" />
                <NumberField source="amount" label='Monto' />
                {(balanceShow === "true") ? <NumberField source="balance" label='Balance' /> : <></>}
                <BooleanField source="ignored" label="Oculto" />
                <TextField source="createdAt" label="Fecha" />
            </Datagrid>
        </List>
    );
}

export const TransactionCreate = props => {
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    if (!permissions.includes("users.list")) {
        return <Redirect to="401" />
    }
    let opciones = [];
    if (permissions.includes("transactions.create_pago")) {
        opciones.push({ id: 'pago', name: 'Crear pago' });
    }
    if (permissions.includes("transactions.create_carga")) {
        opciones.push({ id: 'carga', name: 'Cargar dinero técnico' });
    }
    if (permissions.includes("transactions.create_retiro")) {
        opciones.push({ id: 'retiro', name: 'Retirar dinero' });
    }
    if (permissions.includes("transactions.create_devolucion")) {
        opciones.push({ id: 'devolucion', name: 'Devolución dinero' });
    }
    return (
        <Create {...props}>
            <SimpleForm submitOnEnter={false}>
                {(permissions.includes("users.list")) &&
                    <ReferenceInput
                        label="Usuario" source="userId" reference="users"
                        allowEmpty
                        sort={{ field: 'firstname', order: 'ASC' }}
                        optionValue="username"
                        suggestionLimit={10}
                        // shouldRenderSuggestions={(value) => value.trim() > 2}
                        alwaysOn>
                        {/* filterToQuery={searchText => ({ filtro: searchText })} */}
                        {/* <SelectInput optionText={record => `${record.firstname} ${record.lastname}`}/> */}
                        <AutocompleteInput optionText="filtro" />
                    </ReferenceInput>
                }
                <TextInput source="machineId" label='Máquina (si no hay que cargar)' />
                <NumberInput validate={[required()]} source="amount" label="Monto" step={100} min={1000} max={20000} />
                <SelectInput validate={[required()]} source="transactionType" label="Tipo de transacción" choices={opciones} />
            </SimpleForm>
        </Create>
    )
};

// function codeValidation(code) {
//     if (code === "") {
//         return null;
//     }
//     if (/^[Aa][Cc][Tt]\.[Ee][Qq]-(?<!\d)(?!0000)\d{4}(?!\d)/.test(code)) {
//         return null;
//     }
//     return "Código no cumple el formato ACT.EQ-1234";
// }

export const TransactionShow = props => {
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    return (
        <Show {...props}>
            <SimpleShowLayout>
                <TextField source="transactionId" label="Id" sortable={false} />
                {(permissions.includes("users.list")) ?
                    <ReferenceField source="userId" label='Usuario' reference="users" link="show">
                        <FunctionField label="Nombre completo" render={record => `${record.firstname} ${record.lastname}`} />
                    </ReferenceField>
                    : null}
                <FunctionField label="Tipo de transacción" render={record => {
                    if (record.role === 'USER' || record.role === 'postgres') {
                        return `${record.transactionType.toUpperCase()}`;
                    } else {
                        if (record.transactionType === 'pago') {
                            return 'USO PERSONAL';
                        }
                        return `${record.transactionType.toUpperCase()}`;
                    }
                }} />
                <NumberField source="amount" label="Monto" />
                <TextField source="machineId" label='Máquina (si no hay es CARGA)' />
            </SimpleShowLayout>
        </Show>
    )
};

const TransactionFilter = (props) => {
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    return (
        <Filter {...props}>
            <TextInput label="Buscar" source="q" alwaysOn />
            {(permissions.includes("users.list")) ?
                <ReferenceInput
                    label="Usuario" source="userId" reference="users"
                    allowEmpty
                    sort={{ field: 'firstname', order: 'ASC' }}
                    optionValue="username"
                    suggestionLimit={25}
                    // shouldRenderSuggestions={(value) => value.trim() > 2}
                    alwaysOn>
                    {/* filterToQuery={searchText => ({ filtro: searchText })} */}
                    {/* <SelectInput optionText={record => `${record.firstname} ${record.lastname}`}/> */}
                    <AutocompleteInput optionText="filtro" />
                </ReferenceInput>
                : null}
            <SelectInput source="transactionType" label="Tipo de transacción" choices={[
                { id: 'pago-user', name: 'Uso de máquina' },
                { id: 'pago-tech', name: 'Uso de personal' },
                { id: 'carga', name: 'Carga de saldo' },
                { id: 'carga manual', name: 'Carga personal' },
                { id: 'retiro', name: 'Retiro' },
                { id: 'devolucion', name: 'Devolución' },
            ]} />
            <SelectInput source="machine_type" label="Tipo de máquina" choices={[
                { id: 'secadora', name: 'Secadora' },
                { id: 'lavadora', name: 'Lavadora' }
            ]} />
            <DateBetweenInput source="createdAt" label="Fecha de creación" />
            {(permissions.includes("machines.list")) ?
                <ReferenceInput
                    label="Máquina" source="machineId" reference="machines"
                    allowEmpty
                    sort={{ field: 'createdAt', order: 'ASC' }}
                    optionValue="code"
                    suggestionLimit={25}
                >
                    <AutocompleteInput optionText="code" />
                </ReferenceInput>
                : null}
            {(permissions.includes("buildings.list")) ?
                <ReferenceInput
                    label="Edificio" source="buildingId" reference="buildings"
                    allowEmpty
                    sort={{ field: 'createdAt', order: 'ASC' }}
                    optionValue="address"
                    suggestionLimit={25}
                >
                    <AutocompleteInput optionText="address" />
                </ReferenceInput>
                : null}
        </Filter>
    )
};
